(function () {
  if (window.RealseeShopTelemetry) {
    return;
  }

  var EVENT_NAME_TO_ID_MAP = {
    pageView: '10188',
    likeClick: '10334',
    downloadClick: '10340',
    downloadStay: '10347',
    downloadAuto: '10346',
    marketingEvent: '10395',
    userInfo: '10199',
    userInteraction: '10200',
    buyClick: '10532',
    serviceView: '10535',
    serviceClick: '10536'
  };

  var WINDOW_QUEUE_KEY = '__telemetry_q__';
  var VIEW_OBSERVER = null;
  var VIEW_SENT_KEYS = new Set();
  var CONTACT_SUCCESS_VISIBLE = false;
  var DOWNLOAD_AUTO_SENT = false;

  function uuid() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') {
      return window.crypto.randomUUID();
    }

    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
      var random = Math.random() * 16 | 0;
      var value = char === 'x' ? random : (random & 0x3 | 0x8);

      return value.toString(16);
    });
  }

  function merge(target) {
    var result = {};

    for (var index = 0; index < arguments.length; index += 1) {
      var source = arguments[index];

      if (!source || typeof source !== 'object') {
        continue;
      }

      Object.keys(source).forEach(function (key) {
        result[key] = source[key];
      });
    }

    return result;
  }

  function toNumber(value, fallbackValue) {
    var nextValue = Number(value);

    return Number.isFinite(nextValue) ? nextValue : fallbackValue;
  }

  function getConfig() {
    return merge(
      {
        enabled: false,
        appKey: '',
        env: 'development',
        page_type: '',
        template: '',
        locale: '',
        design_mode: false
      },
      window.RealseeTelemetryConfig || {}
    );
  }

  function getPageContext() {
    var config = getConfig();

    return {
      pageType: config.page_type || (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType) || '',
      template: config.template || '',
      locale: config.locale || ''
    };
  }

  function getPathname() {
    return (window.location.pathname || '').toLowerCase();
  }

  function isDownloadPage() {
    return getPathname().indexOf('download-realsee-vr') !== -1;
  }

  function inferDownloadActionType(targetUrl) {
    if (!targetUrl) {
      return 1;
    }

    var normalizedUrl = String(targetUrl).toLowerCase();

    if (normalizedUrl.indexOf('apps.apple.com') !== -1 || normalizedUrl.indexOf('app store') !== -1) {
      return 2;
    }

    if (
      normalizedUrl.indexOf('play.google.com') !== -1 ||
      normalizedUrl.indexOf('.apk') !== -1 ||
      normalizedUrl.indexOf('google play') !== -1
    ) {
      return 3;
    }

    return 1;
  }

  function mirrorToDataLayer(eventName, eventId, payload, meta) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: eventName,
      telemetry_id: eventId,
      telemetry_payload: payload,
      pp_uid: meta && meta.pp_uid ? meta.pp_uid : undefined,
      pp_page_type: getPageContext().pageType,
      pp_template: getPageContext().template
    });
  }

  function createManager() {
    var requestId = '';
    var userId = '';
    var eventCommonData;
    var queue = [];
    var status = 'initial';
    var enabled = false;

    function getSDK() {
      return window.RealseeTelemetry;
    }

    function getEventCommonData() {
      if (!requestId) {
        requestId = uuid();
      }

      if (!eventCommonData) {
        eventCommonData = {
          custom_type: 'realsee',
          env: getConfig().env === 'production' ? 'production' : 'development',
          pid: 'rushi_website',
          request_id: requestId,
          user_id: userId || '',
          platform_type: 'web'
        };
      }

      return eventCommonData;
    }

    function flushQueue() {
      if (Array.isArray(window[WINDOW_QUEUE_KEY])) {
        queue.unshift.apply(queue, window[WINDOW_QUEUE_KEY]);
      }

      delete window[WINDOW_QUEUE_KEY];

      var pendingQueue = queue.slice();
      queue = [];

      pendingQueue.forEach(function (item) {
        send(item.eventName, merge(item.eventData, { fromQueue: 1 }), item.meta);
      });
    }

    function bindUserInteraction() {
      ['click', 'scroll', 'keydown'].forEach(function (eventName) {
        document.addEventListener(eventName, function (event) {
          send('userInteraction', {
            type: event.type,
            timestamp: Date.now()
          });
        }, {
          once: true,
          passive: true
        });
      });
    }

    function init() {
      if (status !== 'initial') {
        return;
      }

      var config = getConfig();
      enabled = Boolean(config.enabled) && !config.design_mode;

      if (!enabled) {
        status = 'success';
        return;
      }

      var sdk = getSDK();

      if (!sdk || typeof sdk.setConfig !== 'function' || typeof sdk.pushEvent !== 'function') {
        status = 'error';
        return;
      }

      try {
        getEventCommonData();
        sdk.setConfig({
          appKey: config.appKey,
          env: config.env,
          i18n: true,
          autoInitFiveEvent: false,
          logger: config.env === 'development'
        });
        status = 'success';
        send('pageView', { timestamp: Date.now() });
        flushQueue();
        bindUserInteraction();
      } catch (error) {
        status = 'error';
      }
    }

    function setUserId(nextUserId) {
      userId = nextUserId || '';
      eventCommonData = merge(getEventCommonData(), { user_id: userId });

      if (userId) {
        send('userInfo', { user_id: userId });
      }
    }

    function send(eventName, eventData, meta) {
      if (eventData === void 0) {
        eventData = {};
      }

      if (!enabled) {
        return false;
      }

      if (status !== 'success') {
        queue.push({
          eventName: eventName,
          eventData: eventData,
          meta: meta
        });
        return false;
      }

      var eventId = EVENT_NAME_TO_ID_MAP[eventName];

      if (!eventId) {
        return false;
      }

      var payload = merge(
        getEventCommonData(),
        {
          url: eventData.url || window.location.href,
          timestamp: eventData.timestamp || Date.now()
        },
        eventData
      );

      window.RealseeTelemetry.pushEvent({
        name: eventName,
        id: eventId,
        data: payload
      });

      mirrorToDataLayer(eventName, eventId, payload, meta);
      return true;
    }

    return {
      init: init,
      send: send,
      setUserId: setUserId,
      getStatus: function () {
        return status;
      }
    };
  }

  var manager = createManager();

  function findTrackTarget(node) {
    if (!node || typeof node.closest !== 'function') {
      return null;
    }

    return node.closest('[data-analysis-event-action][data-pp-uid], [data-open-chat], yg-download, a[href*="download-realsee-vr"], a[href*="apps.apple.com"], a[href*="play.google.com"]');
  }

  function sendMarketingEvent(target) {
    var targetId = target.getAttribute('data-pp-uid');

    if (!targetId) {
      return;
    }

    manager.send('marketingEvent', {
      url: window.location.href,
      target_id: targetId
    }, {
      pp_uid: targetId
    });
  }

  function sendServiceClick(target) {
    var targetId = target && typeof target.getAttribute === 'function' ? target.getAttribute('data-pp-uid') : undefined;

    manager.send('serviceClick', {}, {
      pp_uid: targetId || undefined
    });
  }

  function sendDownloadClick(target) {
    var targetUrl = target.getAttribute('data-pp-target-url') || target.getAttribute('data-download-link') || target.getAttribute('href') || '';
    var actionType = toNumber(target.getAttribute('data-pp-action-type'), inferDownloadActionType(targetUrl));
    var targetId = target.getAttribute('data-pp-uid');

    manager.send('downloadClick', {
      url: window.location.href,
      action_type: actionType
    }, {
      pp_uid: targetId || undefined
    });
  }

  function sendBuyClickFromForm(form, submitter) {
    var button = submitter && typeof submitter.closest === 'function'
      ? submitter.closest('[data-pp-event="buyClick"], [data-pp-goods-id]')
      : null;

    if (!button) {
      button = form.querySelector('[data-pp-event="buyClick"], [data-pp-goods-id]');
    }

    if (!button) {
      return;
    }

    var goodsId = button.getAttribute('data-pp-goods-id');
    var skuInput = form.querySelector('[name="id"]');
    var skuId = skuInput ? skuInput.value : button.getAttribute('data-pp-sku-id');
    var targetId = button.getAttribute('data-pp-uid');

    if (!goodsId || !skuId) {
      return;
    }

    manager.send('buyClick', {
      goods_id: goodsId,
      sku_id: skuId
    }, {
      pp_uid: targetId || undefined
    });
  }

  function handleClick(event) {
    var target = findTrackTarget(event.target);

    if (!target) {
      return;
    }

    var action = target.getAttribute('data-analysis-event-action');
    var eventName = target.getAttribute('data-pp-event');

    if (target.matches('[data-open-chat]') && !eventName) {
      sendServiceClick(target);
      return;
    }

    if (target.tagName === 'YG-DOWNLOAD' && !eventName) {
      sendDownloadClick(target);
      return;
    }

    if (target.tagName === 'A' && !eventName) {
      var href = target.getAttribute('href') || '';

      if (href.indexOf('download-realsee-vr') !== -1 || href.indexOf('apps.apple.com') !== -1 || href.indexOf('play.google.com') !== -1) {
        sendDownloadClick(target);
        return;
      }
    }

    if (action !== 'click') {
      return;
    }

    if (!eventName || eventName === 'marketingEvent') {
      sendMarketingEvent(target);
      return;
    }

    if (eventName === 'serviceClick') {
      sendServiceClick(target);
      return;
    }

    if (eventName === 'downloadClick') {
      sendDownloadClick(target);
    }
  }

  function observeViewTargets() {
    if (!('IntersectionObserver' in window)) {
      return;
    }

    if (!VIEW_OBSERVER) {
      VIEW_OBSERVER = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            return;
          }

          var target = entry.target;
          var eventName = target.getAttribute('data-pp-event');
          var action = target.getAttribute('data-analysis-event-action');
          var targetId = target.getAttribute('data-pp-uid') || '';
          var viewKey = eventName + ':' + targetId;

          if (action !== 'view' || !eventName || VIEW_SENT_KEYS.has(viewKey)) {
            return;
          }

          VIEW_SENT_KEYS.add(viewKey);
          manager.send(eventName, {}, {
            pp_uid: targetId || undefined
          });
          VIEW_OBSERVER.unobserve(target);
        });
      }, {
        threshold: 0.35
      });
    }

    document.querySelectorAll('[data-analysis-event-action="view"][data-pp-event]').forEach(function (element) {
      VIEW_OBSERVER.observe(element);
    });
  }

  function bindContactSuccessTracking() {
    function sendContactSuccessEvent() {
      var config = document.querySelector('.yg-success-popup-config');
      var targetId = config ? config.getAttribute('data-pp-uid') : undefined;

      manager.send('serviceClick', {}, {
        pp_uid: targetId || undefined
      });
    }

    document.addEventListener('YG:openContactSuccessPopup', function () {
      if (CONTACT_SUCCESS_VISIBLE) {
        return;
      }

      CONTACT_SUCCESS_VISIBLE = true;
      sendContactSuccessEvent();
    });

    var popup = document.querySelector('yg-contact-success-popup');

    if (!popup || !('MutationObserver' in window)) {
      return;
    }

    var observer = new MutationObserver(function () {
      var isVisible = popup.style.display !== 'none';

      if (isVisible && !CONTACT_SUCCESS_VISIBLE) {
        CONTACT_SUCCESS_VISIBLE = true;
        sendContactSuccessEvent();
      }

      if (!isVisible) {
        CONTACT_SUCCESS_VISIBLE = false;
      }
    });

    observer.observe(popup, {
      attributes: true,
      attributeFilter: ['style', 'class']
    });
  }

  function bindDownloadPageTracking() {
    if (!isDownloadPage()) {
      return;
    }

    if (!DOWNLOAD_AUTO_SENT && window.matchMedia && window.matchMedia('(max-width: 699px)').matches) {
      DOWNLOAD_AUTO_SENT = true;
      manager.send('downloadAuto', {
        url: window.location.href
      });
    }

    setTimeout(function () {
      if (document.visibilityState === 'visible') {
        manager.send('downloadStay', {
          url: window.location.href
        });
      }
    }, 3000);
  }

  function bootstrap() {
    manager.init();
    document.addEventListener('click', handleClick, true);
    document.addEventListener('submit', function (event) {
      var form = event.target;
      var submitter = event.submitter || document.activeElement;

      if (!form || !form.matches || !form.matches('form[is="product-form"]')) {
        return;
      }

      sendBuyClickFromForm(form, submitter);
    }, true);
    document.addEventListener('shopify:section:load', observeViewTargets);
    observeViewTargets();
    bindContactSuccessTracking();
    bindDownloadPageTracking();
  }

  window.RealseeShopTelemetry = {
    init: manager.init,
    send: manager.send,
    setUserId: manager.setUserId
  };

  bootstrap();
})();
